"use client"

import React from "react"
import { FaSun, FaMoon } from "react-icons/fa"

const DarkMode = () => {
  const [theme, setTheme] = React.useState(localStorage.getItem("theme") ? localStorage.getItem("theme") : "light")

  const element = document.documentElement

  React.useEffect(() => {
    if (theme === "dark") {
      element.classList.add("dark")
      localStorage.setItem("theme", "dark")
    } else {
      element.classList.remove("dark")
      localStorage.setItem("theme", "light")
    }
  }, [theme])

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light")
  }

  return (
    <div className="relative">
      <button
        onClick={toggleTheme}
        className="relative w-14 h-7 bg-gray-300 dark:bg-gray-600 rounded-full p-1 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-gray-900"
        aria-label="Toggle dark mode"
      >
        {/* Toggle Background */}
        <div
          className={`absolute inset-1 rounded-full transition-all duration-300 ${
            theme === "dark" ? "bg-gray-800" : "bg-white"
          }`}
        />

        {/* Toggle Button */}
        <div
          className={`relative w-5 h-5 rounded-full shadow-lg transform transition-all duration-300 flex items-center justify-center ${
            theme === "dark" ? "translate-x-7 bg-yellow-400 text-gray-800" : "translate-x-0 bg-gray-800 text-yellow-400"
          }`}
        >
          {theme === "dark" ? <FaSun className="w-3 h-3" /> : <FaMoon className="w-3 h-3" />}
        </div>

        {/* Background Icons */}
        <div className="absolute inset-0 flex items-center justify-between px-2 pointer-events-none">
          <FaSun
            className={`w-3 h-3 transition-opacity duration-300 ${
              theme === "light" ? "opacity-60 text-gray-600" : "opacity-30 text-gray-400"
            }`}
          />
          <FaMoon
            className={`w-3 h-3 transition-opacity duration-300 ${
              theme === "dark" ? "opacity-60 text-gray-300" : "opacity-30 text-gray-500"
            }`}
          />
        </div>
      </button>
    </div>
  )
}

export default DarkMode
